export default __webpack_public_path__ + "static/PADF-English_Blue-8e97c3ec42cf5103bf5f4a29799709a5.png";